import { useMutation } from "@apollo/client";
import { AppContext } from "AppContainer";
import { LOGOUT } from "auth/graphql";
import Button from "components/Button";
import MainRouteLayout from "components/MainRouteLayout";
import mixpanel from "mixpanel-browser";
import Inventory from "pages/inventory";
import ProductionPage from "pages/production";
import RegisterPage from "pages/register";
import Support from "pages/support";
import { useContext, useEffect } from "react";
import { BsFillExclamationCircleFill } from "react-icons/bs";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import IndexPage from "./pages";
import ESGPages from "./pages/esg";

const AppRoutes = () => {
  const location = useLocation();

  const { user } = useContext(AppContext);

  useEffect(() => {
    if (location && location.pathname) {
      mixpanel.track_pageview();
    }
  }, [location]);

  console.log("user", user);

  // If this supplier has not onboarded yet, redirect to register page.
  if (
    user &&
    user.supplier &&
    ["DRAFT", "PENDING", "REJECTED"].includes(user.supplier.state)
  )
    return (
      <Routes>
        <Route element={<MainRouteLayout />}>
          <Route path="/" element={<IndexPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="*" element={<Navigate to="/register" />} />
        </Route>
      </Routes>
    );

  return (
    <Routes>
      <Route element={<MainRouteLayout />}>
        <Route path="/" element={<IndexPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/esg/*" element={<ESGPages />} />
        <Route path="/production/*" element={<ProductionPage />} />
        <Route path="/inventory/*" element={<Inventory />} />
        <Route path="/support" element={<Support />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Routes>
  );
};

export const UserWithoutSupplier = ({ user }) => {
  const [signOut, signOutRes] = useMutation(LOGOUT, {
    onCompleted() {
      window.location.href = "/login";
    },
    onError(error) {
      toast.error(error.message);
    },
  });

  return (
    <div className="min-h-screen flex items-center justify-center w-full h-32">
      <div className="space-y-8 -mt-20 px-6">
        <div className="flex justify-center text-red-600">
          <BsFillExclamationCircleFill size={72} />
        </div>

        <h3 className="text-center">Waboba Supplier Portal</h3>

        <div className="text-center leading-loose max-w-3xl">
          This account({user.email}) is not associated with any supplier. Please
          contact Waboba system administrator to associate it with a supplier
          and then refresh the page to login!
          此帐号还没有关联供应商，请联系Waboba系统管理员关联后再刷新页面登录！
        </div>
        <div className="flex justify-center space-x-8">
          <Button onClick={() => window.location.reload()}>
            Refresh 刷新页面
          </Button>
          <Button danger onClick={signOut} loading={signOutRes.loading}>
            Sign Out 退出登录
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AppRoutes;
